import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "squareup.featurama.feature_sets";
/** Activation status of a feature set. */
export let ActivationStatus = /* @__PURE__ */ function(ActivationStatus) {
	/** ACTIVATION_STATUS_DO_NOT_USE - Do not use this value. * */
	ActivationStatus[ActivationStatus["ACTIVATION_STATUS_DO_NOT_USE"] = 0] = "ACTIVATION_STATUS_DO_NOT_USE";
	/** INACTIVE - The feature set has never been active. * */
	ActivationStatus[ActivationStatus["INACTIVE"] = 1] = "INACTIVE";
	/** ACTIVE - The feature set is currently active. * */
	ActivationStatus[ActivationStatus["ACTIVE"] = 2] = "ACTIVE";
	/** DEACTIVATED - The feature set was previously active, but is now not active. * */
	ActivationStatus[ActivationStatus["DEACTIVATED"] = 3] = "DEACTIVATED";
	return ActivationStatus;
}({});
/** Unique identifiers for all feature sets */
export let FeatureSetKey = /* @__PURE__ */ function(FeatureSetKey) {
	FeatureSetKey[FeatureSetKey["FEATURE_SET_DO_NOT_USE"] = 0] = "FEATURE_SET_DO_NOT_USE";
	FeatureSetKey[FeatureSetKey["APPOINTMENTS"] = 1] = "APPOINTMENTS";
	FeatureSetKey[FeatureSetKey["RESTAURANTS"] = 2] = "RESTAURANTS";
	FeatureSetKey[FeatureSetKey["RETAIL"] = 3] = "RETAIL";
	return FeatureSetKey;
}({});
function createBaseFeatureSetActivationStatusForSeller() {
	return {
		$type: "squareup.featurama.feature_sets.FeatureSetActivationStatusForSeller",
		activationStatus: undefined,
		isActive: undefined
	};
}
export const FeatureSetActivationStatusForSeller = {
	$type: "squareup.featurama.feature_sets.FeatureSetActivationStatusForSeller",
	encode(message, writer = new BinaryWriter()) {
		if (message.activationStatus !== undefined) {
			writer.uint32(8).int32(message.activationStatus);
		}
		if (message.isActive !== undefined) {
			writer.uint32(16).bool(message.isActive);
		}
		return writer;
	},
	decode(input, length) {
		const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
		const end = length === undefined ? reader.len : reader.pos + length;
		const message = createBaseFeatureSetActivationStatusForSeller();
		while (reader.pos < end) {
			const tag = reader.uint32();
			switch (tag >>> 3) {
				case 1: {
					if (tag !== 8) {
						break;
					}
					message.activationStatus = reader.int32();
					continue;
				}
				case 2: {
					if (tag !== 16) {
						break;
					}
					message.isActive = reader.bool();
					continue;
				}
			}
			if ((tag & 7) === 4 || tag === 0) {
				break;
			}
			reader.skip(tag & 7);
		}
		return message;
	},
	create(base) {
		return FeatureSetActivationStatusForSeller.fromPartial(base ?? {});
	},
	fromPartial(object) {
		const message = createBaseFeatureSetActivationStatusForSeller();
		message.activationStatus = object.activationStatus ?? undefined;
		message.isActive = object.isActive ?? undefined;
		return message;
	}
};
function createBaseFeatureSetStatusForSeller() {
	return {
		$type: "squareup.featurama.feature_sets.FeatureSetStatusForSeller",
		featureSetKey: undefined,
		activationStatus: undefined
	};
}
export const FeatureSetStatusForSeller = {
	$type: "squareup.featurama.feature_sets.FeatureSetStatusForSeller",
	encode(message, writer = new BinaryWriter()) {
		if (message.featureSetKey !== undefined) {
			writer.uint32(8).int32(message.featureSetKey);
		}
		if (message.activationStatus !== undefined) {
			FeatureSetActivationStatusForSeller.encode(message.activationStatus, writer.uint32(18).fork()).join();
		}
		return writer;
	},
	decode(input, length) {
		const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
		const end = length === undefined ? reader.len : reader.pos + length;
		const message = createBaseFeatureSetStatusForSeller();
		while (reader.pos < end) {
			const tag = reader.uint32();
			switch (tag >>> 3) {
				case 1: {
					if (tag !== 8) {
						break;
					}
					message.featureSetKey = reader.int32();
					continue;
				}
				case 2: {
					if (tag !== 18) {
						break;
					}
					message.activationStatus = FeatureSetActivationStatusForSeller.decode(reader, reader.uint32());
					continue;
				}
			}
			if ((tag & 7) === 4 || tag === 0) {
				break;
			}
			reader.skip(tag & 7);
		}
		return message;
	},
	create(base) {
		return FeatureSetStatusForSeller.fromPartial(base ?? {});
	},
	fromPartial(object) {
		const message = createBaseFeatureSetStatusForSeller();
		message.featureSetKey = object.featureSetKey ?? undefined;
		message.activationStatus = object.activationStatus !== undefined && object.activationStatus !== null ? FeatureSetActivationStatusForSeller.fromPartial(object.activationStatus) : undefined;
		return message;
	}
};
